module.exports = __webpack_public_path__ + "static/media/arrow-circle-left.97b1f63d.svg";